module.exports = __webpack_public_path__ + "static/archi_proj3-f04ca61a8b1f170f9b873683f8792166.jpg";